declare global {
  interface Window {
    grecaptcha?: {
      ready: (cb: () => void) => void
      execute: (siteKey: string, options: { action: string }) => Promise<string>
    }
  }
}

let recaptchaScriptPromise: Promise<void> | null = null

function getRecaptchaSiteKey(): string {
  const siteKey = document
    .querySelector('meta[name="recaptcha-site-key"]')
    ?.getAttribute('content')
    ?.trim()

  if (!siteKey) {
    throw new Error('Falta configurar VITE_RECAPTCHA_SITE_KEY')
  }

  return siteKey
}

function loadRecaptchaScript(siteKey: string): Promise<void> {
  if (window.grecaptcha) {
    return Promise.resolve()
  }

  if (recaptchaScriptPromise) {
    return recaptchaScriptPromise
  }

  recaptchaScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('No se pudo cargar Google reCAPTCHA'))
    document.head.appendChild(script)
  })

  return recaptchaScriptPromise
}

export async function getRecaptchaToken(action: string): Promise<string> {
  const siteKey = getRecaptchaSiteKey()
  await loadRecaptchaScript(siteKey)

  return await new Promise<string>((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error('Google reCAPTCHA no esta disponible'))
      return
    }

    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha!.execute(siteKey, { action })
        resolve(token)
      } catch (error) {
        reject(error)
      }
    })
  })
}
